import validators from '../../../../utilities/validators';

export const singaporeMarketValidator = validators.compose(
    validators.requiredBoolean('marketType.singapore.coe.editable')
);

export const newZealandMarketValidator = validators.compose(
    validators.requiredBoolean('marketType.newZealand.ppsr.editable'),
    validators.requiredBoolean('marketType.newZealand.estFee.editable'),
    validators.requiredBoolean('marketType.newZealand.bankEstFee.editable'),
    validators.requiredBoolean('marketType.newZealand.nzFees.viewable')
);
